module.exports = __webpack_public_path__ + "img/vino-degust-empty@2x.5d5ddc2e.png";